import styled from "styled-components";

import { AIButton } from "@similarweb/ai-kit";

export const StyledAiButton = styled(AIButton)`
    align-self: flex-start;
`;
